import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "./contexts/authContext";
import axios from "axios";

const ProtectedRoute = ({ children }) => {
    const { currentUser } = useAuth();
    const [isAllowed, setIsAllowed] = useState(null);

    useEffect(() => {
        const checkAccess = async () => {
            if (!currentUser) {
                setIsAllowed(false);
                return;
            }

            try {
                const email = currentUser.email;

                const [subRes, paymentRes] = await Promise.all([
                    axios.post("https://supremebot-image-latest.onrender.com/check-subscription", { email }),
                    axios.post("https://supremebot-image-latest.onrender.com/check-payment", { email }),
                ]);

                const isSubscribed = subRes?.data?.access === true;
                const hasPaid = paymentRes?.data?.paid === true;

                setIsAllowed(isSubscribed || hasPaid);
            } catch (error) {
                console.error("Error checking access:", error);
                setIsAllowed(false); // Default to false on error
            }
        };

        checkAccess();
    }, [currentUser]);

    if (!currentUser) {
        return <Navigate to="/login" />;
    }

    if (isAllowed === null) {
        return <div>Loading...</div>; // Loading state
    }

    if (!isAllowed) {
        return <Navigate to="/subscriptions" />;
    }

    return children;
};

export default ProtectedRoute;
